module.exports = __webpack_public_path__ + "img/Habitat-Learn-Logo-Light.9895868f.svg";